module.exports = __webpack_public_path__ + "media/images/top/btn_kv-2bc1eeef02d07118e57ddfa4f5f31332.svg";